import type { Namespace, ParseKeys, TFunction } from 'i18next'
import type { ZodObject, ZodRawShape } from 'zod'

export function createGetFieldLabelFactory<
  TSchema extends ZodObject<TSchemaShape>,
  TSchemaShape extends ZodRawShape,
  TKey = keyof TSchemaShape,
>(_: TSchema, translationRootPath: string) {
  return <TNamespace extends Namespace>(t: TFunction<TNamespace>) =>
    (fieldName: TKey) => {
      const label = t(
        `${translationRootPath}.${fieldName}` as ParseKeys<TNamespace>
      )

      return typeof label === 'string' ? label : 'Field'
    }
}
